import { isMobilePhone } from '../analytics/device-context';

/** Upper bound (matches app-config-ready.guard.ts) so a hung CMS fetch can't stall the phone gate; on timeout the flag is absent and the gate fails closed. */
export const MOBILE_BROWSER_GATE_MAX_WAIT_MS = 4000;

/**
 * CMS kill-switch: block a phone UA unless the CMS strictly says `false`.
 *
 * Used to fail *open* (block only on a strict `true`), which made the gate
 * depend on one optional CMS key being present. The SMB build, pointed at its
 * own CMS namespace that never published the key, silently let phones into an
 * app that cannot run on one; the same outage or a gate timeout would do it
 * here. Absence now means "block". The kill-switch is unchanged otherwise — it
 * just has to be set explicitly to `false` to let phones through.
 *
 * Tablets and desktop/laptop UAs are never blocked, flag or not.
 */
export function shouldBlockMobileBrowser(
  isMobileBrowserBlocked: boolean | string | undefined | null,
  ua?: string,
): boolean {
  // Accepts the string "false" as well: the CMS is untyped JSON and already ships
  // `minChromiumMajor` as '100' rather than 100, so a quoted flag is a realistic way
  // for the one escape hatch to be set — and it must not fail silently.
  const phonesAllowed = isMobileBrowserBlocked === false || isMobileBrowserBlocked === 'false';
  return !phonesAllowed && isMobilePhone(ua);
}
